/**
 * The one "nothing here" message — for empty lists, filters without hits and
 * panels that have nothing selected yet.
 *
 * Say what is empty and, if there is one, the next step; no encouragement, no
 * illustration. `compact` is for the inside of a panel or table cell, the
 * default for a whole card or page section.
 */

import type { ReactNode } from 'react';

export interface EmptyStateProps {
  /** The fact, e.g. "Keine offenen Bewertungen". */
  title?: ReactNode;
  /** Optional detail or hint, e.g. which filter hides the rest. */
  children?: ReactNode;
  /** Optional button or link for the obvious next step. */
  action?: ReactNode;
  compact?: boolean;
  className?: string;
}

export function EmptyState({ title, children, action, compact = false, className }: EmptyStateProps): ReactNode {
  const classes = ['empty-state'];
  if (compact) classes.push('compact');
  if (className) classes.push(className);
  return (
    <div className={classes.join(' ')}>
      {title ? <p className="empty-state-title">{title}</p> : null}
      {children ? <div className="empty-state-text">{children}</div> : null}
      {action ? <div className="empty-state-action">{action}</div> : null}
    </div>
  );
}

export default EmptyState;
